export const transformHtmlToPlainText = (html: string): string => {
  html = (html || "").replace("</p>", "</p> ");
  return html.replace(/<[^>]+>/g, "");
};

export const truncateString = (str: string, length: number = 350): string => {
  if (str.length > length) {
    return str.substring(0, length) + "...";
  }
  return str;
};

export const truncateHtmlToPlainText = (html: string, length?: number): string => {
  return truncateString(transformHtmlToPlainText(html), length);
};
